import * as _ from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';

import { GROUPS as CONSTS, ROLE } from '../../const';
import { getConfiguration, getStudentsWithId, MODES } from './AssignmentsContentPanel/assignmentsContentPanelService';
import * as assignmentsDrawerActions from '../../actions/assignmentsDrawerActions';
import * as lessonListContainerService from './LessonListContainer/lessonListContainerService';
import * as bookActions from '../../actions/bookActions';
import * as classroomActions from '../../actions/classroom/classroomActions';
import * as taskActions from '../../actions/taskActions';
import AssignmentsContentPanel from './AssignmentsContentPanel/AssignmentsContentPanel';
import MultipleSelectionPanel from './MultipleSelectionPanel';
import { I18n } from 'react-redux-i18n-lite';
import dayjs from 'dayjs';
import { DrawerCommonPanelCustom } from '../classroom/students/AddUsers/AddUserComponents';
import { filterTaskUsers } from '../../utils/AssignContentPanelUtils';

const PANELS = {
  CREATE_ASSIGNMENT: 'CREATE_ASSIGNMENT',
  MULTIPLE_SELECTION: 'MULTIPLE_SELECTION'
};

export class CreateAssignmentsContent extends Component {
  state = {
    panel: PANELS.CREATE_ASSIGNMENT,
    currentSelection: {
      users: []
    },
    lessons: {},
    datesContainerState: {
      currentDate: dayjs(), // value used to validate if task dates are right,
      hasInteraction: false
    },
    isAllChecked: false
  };

  resetActivitiesStateIfEmpty = activities => {
    const { assignmentsDrawerActions } = this.props;
    const hasActivities = activities && activities.length;

    if (!hasActivities) {
      assignmentsDrawerActions.onCheckedActivitiesChange([]);
    }
  };

  componentDidMount() {
    const {
      activities,
      checkedActivities,
      selectedGroup,
      isAppOnline,
      classroom,
      classroomActions,
      assignmentsDrawerActions,
      taskActions
    } = this.props;
    const mode = isAppOnline ? MODES.CREATE : MODES.READ;
    classroomActions.getClassroomParticipants(classroom.id);
    this.resetActivitiesStateIfEmpty(activities);

    this.setState({
      currentSelection: {
        ...selectedGroup,
        users: selectedGroup.users || []
      }
    });
    if (!_.isEmpty(activities)) {
      this.setState(
        { lessons: lessonListContainerService.getLessonsAndActivities(activities, checkedActivities) },
        () => {
          if (getConfiguration(mode).activities) {
            this.updateAllActivitiesChecks(); // Si es editable inicializamos con todos los checks.
          }
        }
      );
    }

    taskActions.setTaskContentsNotFound(false);

    assignmentsDrawerActions.setStartDate();
    assignmentsDrawerActions.setDueDate();
  }

  setDatesContainerInteraction = hasInteraction => {
    const { datesContainerState } = this.state;
    this.setState(Object.assign({ datesContainerState }, { hasInteraction }));
  };

  componentDidUpdate(prevProps) {
    const { selectedGroup, checkedActivities, activities, isAppOnline } = this.props;

    const mode = isAppOnline ? MODES.CREATE : MODES.READ;
    const changedSelectedGroup = prevProps.selectedGroup !== selectedGroup;
    const changedCheckedActivities = prevProps.checkedActivities !== checkedActivities;

    if (changedSelectedGroup && selectedGroup.isGroup) {
      this.setState({
        currentSelection: {
          ...selectedGroup,
          users: selectedGroup.users || []
        },
        checkedActivities: changedCheckedActivities ? checkedActivities : prevProps.checkedActivities
      });
    }

    if (activities !== prevProps.activities) {
      this.resetActivitiesStateIfEmpty(activities);
      this.setState(
        {
          lessons: lessonListContainerService.getLessonsAndActivities(activities, checkedActivities)
        },
        () => {
          if (getConfiguration(mode).activities) {
            this.updateAllActivitiesChecks(); // Si es editable inicializamos con todos los checks.
          }
        }
      );
    }
  }

  updateAllActivitiesChecks = () => {
    const { lessons, isAllChecked } = this.state;
    const { assignmentsDrawerActions } = this.props;

    Object.values(lessons).forEach(lesson => {
      lesson.checked = !isAllChecked;
      Object.values(lesson.activities).forEach(activity => {
        activity.checked = !isAllChecked;
      });
    });

    this.setState({ lessons: lessons, isAllChecked: !isAllChecked });
    assignmentsDrawerActions.onCheckedActivitiesChange(lessonListContainerService.getActivitiesChecked(lessons));
  };

  componentWillUnmount = () => {
    const { bookActions, assignmentsDrawerActions } = this.props;

    bookActions.setActivities();
    assignmentsDrawerActions.setSelectedGroup(CONSTS.EVERYONE);
    assignmentsDrawerActions.onCheckedActivitiesChange();
    assignmentsDrawerActions.setDescriptionTask();
    assignmentsDrawerActions.setTitleTask();
    assignmentsDrawerActions.setAllowFile();
  };

  getTask = () => {
    const {
      allowUserCommentResponse,
      students,
      activities,
      groups,
      selectedGroup,
      startDate,
      dueDate,
      classroom,
      book,
      checkedActivities,
      description,
      allowFile,
      title
    } = this.props;

    return {
      startDate,
      dueDate,
      selectedGroup,
      groups,
      students,
      activities,
      classroom,
      book,
      checkedActivities,
      description,
      title,
      allowFile,
      allowUserCommentResponse
    };
  };

  togglePanel = panel => {
    this.setState({
      panel
    });
  };

  selectStudent = newSelection => {
    const { currentSelection } = this.state;

    const users = currentSelection.users.filter(user => user._id !== newSelection._id);

    this.setState({
      currentSelection: {
        users: users.length === currentSelection.users.length ? currentSelection.users.concat(newSelection) : users
      }
    });
  };

  setLessons = lessons => {
    this.setState({ lessons });
  };

  setAllChecked = isAllChecked => {
    this.setState({ isAllChecked });
  };

  setSelected = () => {
    const { currentSelection } = this.state;
    const { assignmentsDrawerActions } = this.props;

    assignmentsDrawerActions.setSelectedGroup(getStudentsWithId(currentSelection));
    this.togglePanel(PANELS.CREATE_ASSIGNMENT);
  };

  renderMultipleSelection = () => {
    const { currentSelection } = this.state;
    const { selectedGroup } = this.props;
    const { lessons } = this.state;
    const task = this.getTask();
    /*    const objLessons = {};
  task.checkedActivities.map(chk => {
      const existLesson = Object.keys(lessons).find(less => less === chk);
      if (existLesson) {
        objLessons[existLesson] = lessons[existLesson];
      }
    });*/
    const filteredUsers = filterTaskUsers(this.props.groups, this.props.isAppOnline, lessons, task);

    const hideBottomRow = currentSelection.isGroup || currentSelection.id === selectedGroup.id;
    return (
      <DrawerCommonPanelCustom
        closePanel={() => this.togglePanel(PANELS.CREATE_ASSIGNMENT)}
        hideRowButtons={hideBottomRow}
        panelHeaderTitle={I18n.t('panels.assignment.newAssignment')}
        showCancelButton={true}
        handleSecondaryButtonClick={() => this.togglePanel(PANELS.CREATE_ASSIGNMENT)}
        primaryButtonText={'common.add'}
        secondaryButtonText={'common.back'}
        icon={'left-chevron'}
        onPrimaryButtonClick={this.setSelected}
      >
        <MultipleSelectionPanel
          students={filteredUsers.availableStudents}
          currentSelection={currentSelection.users}
          selectStudent={this.selectStudent}
        />
      </DrawerCommonPanelCustom>
    );
  };

  renderAssignmentContentPanel = () => {
    const { isAppOnline, skinColors } = this.props;
    const { lessons, isAllChecked, datesContainerState } = this.state;
    const mode = isAppOnline ? MODES.CREATE : MODES.READ;
    const task = this.getTask();
    /*    const objLessons = {};
   task.checkedActivities.map(chk => {
      const existLesson = Object.keys(lessons).find(less => less === chk);
      if (existLesson) {
        objLessons[existLesson] = lessons[existLesson];
      }
    });*/

    const filteredUsers = filterTaskUsers(this.props.groups, this.props.isAppOnline, lessons, task);

    return (
      <AssignmentsContentPanel
        setDatesContainerInteraction={this.setDatesContainerInteraction}
        datesContainerState={datesContainerState}
        lessons={lessons}
        isAllChecked={isAllChecked}
        updateAllActivitiesChecks={this.updateAllActivitiesChecks}
        setAllChecked={this.setAllChecked}
        setLessons={this.setLessons}
        openChooseMultiple={() => this.togglePanel(PANELS.MULTIPLE_SELECTION)}
        task={this.getTask()}
        mode={mode}
        colors={skinColors}
        isAppOnline={this.props.isAppOnline}
        filteredUsers={Object.keys(task.book).length ? filteredUsers : { groups: task.groups, users: task.students }}
        isAboutContent={!!Object.keys(task.book).length}
      />
    );
  };

  render() {
    const { panel } = this.state;

    return panel === PANELS.CREATE_ASSIGNMENT ? this.renderAssignmentContentPanel() : this.renderMultipleSelection();
  }
}

CreateAssignmentsContent.propTypes = {
  groups: PropTypes.array,
  students: PropTypes.array,
  selectedGroup: PropTypes.object,
  dueDate: PropTypes.any,
  startDate: PropTypes.any,
  description: PropTypes.string,
  title: PropTypes.string,
  allowFile: PropTypes.bool,
  activities: PropTypes.array,
  checkedActivities: PropTypes.array,
  classroom: PropTypes.object,
  book: PropTypes.object,
  isAppOnline: PropTypes.bool,
  skinColors: PropTypes.object,
  bookActions: PropTypes.object,
  classroomActions: PropTypes.object,
  assignmentsDrawerActions: PropTypes.object,
  taskActions: PropTypes.any
};

function mapStateToProps(state) {
  return {
    groups: state.classrooms.selectedClassroom.groups,
    students: state.classrooms.selectedClassroom.participants.filter(participant => participant.role === ROLE.STUDENT),
    selectedGroup: state.assignmentsDrawerActions.selectedGroup,
    startDate: state.assignmentsDrawerActions.startDate,
    dueDate: state.assignmentsDrawerActions.dueDate,
    activities: state.assignmentsDrawerActions.activities,
    checkedActivities: state.assignmentsDrawerActions.checkedActivities,
    description: state.assignmentsDrawerActions.descriptionTask,
    allowFile: state.assignmentsDrawerActions.allowFile,
    title: state.assignmentsDrawerActions.titleTask,
    classroom: state.classrooms.selectedClassroom.classroom,
    book: state.book.book,
    books: state.book.books,
    isAppOnline: state.connection.status.online,
    skinColors: state.theme.colors
  };
}

function mapDispatchToProps(dispatch) {
  return {
    assignmentsDrawerActions: bindActionCreators(assignmentsDrawerActions, dispatch),
    classroomActions: bindActionCreators(classroomActions, dispatch),
    bookActions: bindActionCreators(bookActions, dispatch),
    taskActions: bindActionCreators(taskActions, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateAssignmentsContent);
